import { Directive, ElementRef, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[uiShowErrorAfterBlur]'
})
export class ShowErrorAfterBlurDirective implements AfterViewInit, OnDestroy {
  private inputElement: HTMLInputElement;
  private isBlurredOnce = false;
  private removeFocusListener: () => void;
  private removeBlurListener: () => void;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.inputElement = this.elementRef.nativeElement.querySelector('input');
    this.renderer.addClass(this.elementRef.nativeElement, 'form-error-hidden');

    this.removeFocusListener = this.renderer.listen(this.inputElement, 'focus', () => {
      if (this.isBlurredOnce) {
        this.renderer.removeClass(this.elementRef.nativeElement, 'form-error-hidden');
      }
    });

    this.removeBlurListener = this.renderer.listen(this.inputElement, 'blur', () => {
      this.isBlurredOnce = true;
      this.renderer.removeClass(this.elementRef.nativeElement, 'form-error-hidden');
    });
  }

  ngOnDestroy(): void {
    if (this.removeFocusListener) {
      this.removeFocusListener();
    }
    if (this.removeBlurListener) {
      this.removeBlurListener();
    }
  }
}